module.exports = __webpack_public_path__ + "static/media/transport bike with packing.35ed7adb.jpg";